(ns iris.posts.headers
  (:require
   [re-frame.core :as re-frame]
   [day8.re-frame.async-flow-fx]
   [iris.events :as events]
   [iris.error.events :as error-events]
   [iris.posts.common :refer [linkify-header]]))

(def http-complete-event :iris.posts.events/http-complete)
(def http-get-header-event :iris.posts.events/http-get-header)
(def http-get-header-success-event :iris.posts.events/http-get-header-success)
(def http-get-header-failure-event :iris.posts.events/http-get-header-failure)
(def http-get-header-flow-event :iris.posts.events/http-get-header-flow)
(def route-posts-load-complete-event :iris.posts.events/route-posts-load-complete)
(def http-render-header-event :iris.posts.events/http-render-header)
(def http-render-header-success-event :iris.posts.events/http-render-header-success)
(def http-render-header-failure-event :iris.posts.events/http-render-header-failure)
(def http-render-header-flow-event :iris.posts.events/http-render-header-flow)
(def http-header-delete-og-image-event :iris.posts.events/http-header-delete-og-image)
(def http-header-delete-og-image-success-event :iris.posts.events/http-header-delete-og-image-success)
(def http-header-delete-og-image-failure-event :iris.posts.events/http-header-delete-og-image-failure)
(def http-header-delete-og-image-flow-event :iris.posts.events/http-header-delete-og-image-flow)
(def http-get-screening-status-event :iris.posts.events/http-get-screening-status)
(def http-get-post-list-batch-event :iris.posts.events/http-get-post-list-batch)
(def route-load-meta-key :iris.posts.events/route-load)

(defn query-route-load [query-params]
  (get (meta query-params) route-load-meta-key))

(re-frame/reg-event-fx
 http-get-header-success-event
 [(events/api-msg-interceptor
   {:id :http-get-header-success-api-msg-interceptor
    ;; ruid to link turned off per request in IRS-54
    ;; :result-modifier-fn (fn [msg] (linkify-header msg))
    :error-modifier-fn (fn [msg] (str "Header not found: " msg))})]
 (fn [{:keys [db]} [_ data]]
   {:db (if-let [result-data (get-in data [:result :data])]
          (assoc-in db [:posts :header] result-data)
          db)
    :fx [[:dispatch [http-complete-event]]]}))

(re-frame/reg-event-fx
 http-get-header-failure-event
 [(events/api-msg-interceptor
   {:id :http-get-header-failure-api-msg-interceptor
    :debug-message-modifier-fn (fn [msg] (str "Header API failure: " msg))})]
 (fn [{:keys [db]} [_ route-load]]
   ;; this gets triggered on http fail; missing records still return a success response
   {:db db
    :fx [[:dispatch [route-posts-load-complete-event route-load]]
         [:dispatch [http-complete-event]]]}))

(re-frame/reg-event-fx
 http-get-header-event
 (fn [_ [_ id route-load]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Header.Get"
                     :params {:options {:debug false}
                              :data id}}
                    [http-get-header-success-event]
                    [http-get-header-failure-event route-load])))

(defn get-header-flow [qp ruid]
  {:first-dispatch [http-get-header-event ruid (query-route-load qp)]
   :rules [{:when :seen?
            :events http-get-header-success-event
            :dispatch-fn (fn [[_e result-data]]
                           (if (:error result-data)
                             [[::error-events/set-error {:title "Error: Header not found!"
                                                         :message (str "Invalid parameter(s): Header " ruid " NOT FOUND")}]
                              [route-posts-load-complete-event (query-route-load qp)]]
                             [[http-get-screening-status-event ruid {:prevent-http-complete true}]
                              [http-get-post-list-batch-event qp]]))}
           {:when :seen-any-of?
            :events [http-get-header-failure-event http-get-header-success-event]
            :halt? true}]})

(re-frame/reg-event-fx
 http-get-header-flow-event
 [(re-frame/inject-cofx :header-loaded) events/redo-interceptor]
 (fn [cofx [_ qp ruid]]
   (if (not (:header-loaded cofx))
     {:async-flow (get-header-flow qp ruid)}
     {:fx [[:dispatch [http-get-post-list-batch-event qp]]]})))

(re-frame/reg-event-fx
 http-render-header-success-event
 [(events/api-msg-interceptor {:id :http-render-header-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (linkify-header msg))})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [http-complete-event]]]}))

(re-frame/reg-event-fx
 http-render-header-failure-event
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [http-complete-event]]]}))

(re-frame/reg-event-fx
 http-render-header-event
 (fn [_ [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Header.Render"
                     :params {:options {:debug false}
                              :data [id]}}
                    [http-render-header-success-event]
                    [http-render-header-failure-event])))

(defn render-header-flow [ruid]
  {:first-dispatch [http-render-header-event ruid]
   :rules [{:when :seen?
            :events http-render-header-success-event
            :dispatch [http-get-header-event ruid]}
           {:when :seen-any-of?
            :events [http-get-header-success-event http-render-header-failure-event]
            :halt? true}]})

(re-frame/reg-event-fx
 http-render-header-flow-event
 (fn [_ [_ ruid]]
   {:async-flow (render-header-flow ruid)}))

(re-frame/reg-event-fx
 http-header-delete-og-image-success-event
 [(events/api-msg-interceptor {:id :http-header-delete-og-image-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (linkify-header msg))})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [http-complete-event]]]}))

(re-frame/reg-event-fx
 http-header-delete-og-image-failure-event
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [http-complete-event]]]}))

(re-frame/reg-event-fx
 http-header-delete-og-image-event
 (fn [_ [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Header.DeleteOgImage"
                     :params {:options {:debug false}
                              :data id}}
                    [http-header-delete-og-image-success-event]
                    [http-header-delete-og-image-failure-event])))

(defn header-delete-og-image-flow [ruid]
  {:first-dispatch [http-header-delete-og-image-event ruid]
   :rules [{:when :seen?
            :events http-header-delete-og-image-success-event
            :dispatch [http-get-header-event ruid]}
           {:when :seen-any-of?
            :events [http-get-header-success-event http-render-header-failure-event]
            :halt? true}]})

(re-frame/reg-event-fx
 http-header-delete-og-image-flow-event
 (fn [_ [_ ruid]]
   {:async-flow (header-delete-og-image-flow ruid)}))
